"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    { id: 1, name: "Lev Smylie", email: "lsmylie0@example.com", companyName: "Quamba" },
    { id: 2, name: "Dyan Seabridge", email: "dseabridge1@example.com", companyName: "Skivee" },
    { id: 3, name: "Mario Jeffels", email: "mjeffels2@example.com", companyName: "LiveZ" },
    { id: 4, name: "Vita Burrage", email: "vburrage3@example.com", companyName: "Thoughtmix" },
    { id: 5, name: "Tobit Gipson", email: "tgipson4@example.com", companyName: "Linktype" },
    { id: 6, name: "Jule Venmore", email: "jvenmore5@example.com", companyName: "Zoovu" },
    { id: 7, name: "Bellanca Walding", email: "bwalding6@example.com", companyName: "Yambee" },
    { id: 8, name: "Sidonia Hillen", email: "shillen7@example.com", companyName: "Browsebug" },
    { id: 9, name: "Urbanus Mergue", email: "umergue8@example.com", companyName: "Miboo" },
    { id: 10, name: "Felisha Perton", email: "fperton9@example.com", companyName: "Skyndu" },
];
